<button class="btn-icon cross" (click)="removeItem.emit()">
  <div class="cross-icon-block">
    <sd-icon class="icon-size-s" [type]="iconTypes.CROSS"></sd-icon>
  </div>
</button>
